import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const ReferAndEarn = () => {
  return <CommingSoon />;
};

export default ReferAndEarn;
